import { Box, Title, createStyles } from '@mantine/core';
import {  useMedplum } from '@medplum/react';
import { getProjectId } from '../../utils';
import { DescriptionList, DescriptionListEntry } from '../../components/DescriptionList';



export function ProjectDetailsPage(): JSX.Element {
  const medplum = useMedplum();
  const projectId = getProjectId(medplum);
  const result = medplum.get(`admin/projects/${projectId}`).read();

  return (
    <>
      <Title sx={{
        color: "var(--Gray-900, #262930)",
        fontFamily: 'Montserrat',
        fontSize: "22px",
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "30px",
        marginBottom: '10px'
      }}>Details</Title>
      <DescriptionList>
        <DescriptionListEntry term="ID">{result.project.id}</DescriptionListEntry>
        <DescriptionListEntry term="Name">{result.project.name}</DescriptionListEntry>
      </DescriptionList>
    </>
  );
}
